<div class="custom-loader">
  <div class="loader-label"></div>
  <div class="loader-bar">
    <div class="loader-bar-bg">
      <div class="loader-bar-fill">
        @for (block of blocks; track block) {
          <div class="loader-bar-block"></div>
        }
      </div>
    </div>
  </div>
</div>



